import { render } from "./ItemCard.vue?vue&type=template&id=2adeaf90&ts=true"
import script from "./ItemCard.vue?vue&type=script&lang=ts"
export * from "./ItemCard.vue?vue&type=script&lang=ts"

import "./ItemCard.vue?vue&type=style&index=0&id=2adeaf90&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__